import React from 'react'
import { Formik } from 'formik'

import { Button, Form, Col, Row, Card } from '_zari/core'

import * as FormGroups from './formGroups'

import * as TransaccionCrud from 'services/transaccion.service'

const CrearEditar = ({ idTransaccion, refrescarTabla, editarData, refrescarSection }) => {
  const formInitialValues = React.useMemo(
    () => ({
      descripcion: editarData.descripcion || '',
      cuentaContable12EUR: editarData.cuentaContable12EUR || '',
      cuentaContable12PEN: editarData.cuentaContable12PEN || '',
      cuentaContable12USD: editarData.cuentaContable12USD || '',
      flagPrincipal: editarData.flagPrincipal || false
    }),
    [editarData]
  )

  const submitHandler = async data => {
    if (editarData._id) {
      TransaccionCrud.actualizarModeloCuentas12xIdTransaccionxId(idTransaccion, editarData._id, data).then(() => {
        refrescarTabla()
        refrescarSection()
      })
    } else {
      TransaccionCrud.nuevoModeloCuentas12xIdTransaccion(idTransaccion, data).then(() => {
        refrescarTabla()
      })
    }
  }

  return (
    <Card>
      <Card.Header>{editarData._id ? 'Actualizar Modelo Cuentas 12' : 'Nuevo Modelo Cuentas 12'}</Card.Header>
      <Card.Body>
        <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
          {({ errors, handleSubmit, isSubmitting, touched, values }) => (
            <Form>
              <FormGroups.FlagPrincipalFormGroup fIsSubmitting={isSubmitting} iValue={values.flagPrincipal} />
              <Row>
                <Col xs={6} md={12} lg={6}>
                  <FormGroups.DescripcionFormGroup iError={errors.descripcion} iTouched={touched.descripcion} fIsSubmitting={isSubmitting} />
                </Col>
                <Col xs={6} md={12} lg={6}>
                  <FormGroups.SolesFormGroup iError={errors.descripcion} iTouched={touched.descripcion} fIsSubmitting={isSubmitting} />
                </Col>
                <Col xs={6} md={12} lg={6}>
                  <FormGroups.DolaresFormGroup iError={errors.descripcion} iTouched={touched.descripcion} fIsSubmitting={isSubmitting} />
                </Col>
                <Col xs={6} md={12} lg={6}>
                  <FormGroups.EurosFormGroup iError={errors.descripcion} iTouched={touched.descripcion} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <Row>
                <Col className='text-right'>
                  <Button color='secondary' onClick={refrescarSection}>
                    Cancelar
                  </Button>
                  <Button onClick={handleSubmit}>{editarData._id ? 'Actualizar' : 'Crear'}</Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  )
}

export default React.memo(CrearEditar)
